import { FileText } from 'lucide-react'
import { Row } from 'src/shared/components/Semantic/all'

interface FileAttachmentProps {
  name: string
  size?: number
  type?: string
}

const formatSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export const FileAttachment = ({ name, size, type }: FileAttachmentProps) => (
  <Row
    className="items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm"
    title={type}
  >
    <FileText className="h-4 w-4 shrink-0 text-muted-foreground" />
    <span className="truncate text-foreground">{name}</span>
    {size != null && (
      <span className="shrink-0 text-muted-foreground">
        {formatSize(size)}
      </span>
    )}
  </Row>
)
